import { render } from "./Home.vue?vue&type=template&id=7fa297c4"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=7fa297c4&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__